import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { fieldPropTypes } from 'redux-form';
//
import DropdownMultiForFilter from 'components/FormFieldsSimple/DropdownMultiForFilter';
import { ReduxFormElementWrapper } from '../_ReduxFormElementWrapper';

export class DropdownFieldFilters extends Component {
  static propTypes = {
    ...fieldPropTypes,
    onInputChange: PropTypes.func,
  };

  static defaultProps = {
    onInputChange: Function.prototype,
  };

  handleChange = (value) => {
    const { input } = this.props;
    input.onFocus();
    input.onChange(value);
    input.onBlur();
    this.props.onInputChange(value);
  };

  render() {
    const { input } = this.props;
    return (
      <ReduxFormElementWrapper {...this.props} childrenMarginTop="14px">
        <DropdownMultiForFilter
          {...this.props}
          onChange={this.handleChange}
          value={input.value}
        />
      </ReduxFormElementWrapper>
    );
  }
}
